export const templateHamburgueria = {

config:{
cor_primaria:"#101010",
tipo_fundo:"solido",
fonte_principal:"Montserrat"
},

elementos:[

{
id:1,
tipo:"texto",
conteudo:"SMASH BURGER",
pos_x:70,
pos_y:40,
estilo:{fontSize:34,color:"#f1c40f",fontWeight:"bold"}
},

{
id:2,
tipo:"texto",
conteudo:"BURGUERS",
pos_x:120,
pos_y:120,
estilo:{fontSize:20,color:"#fff"}
},

{
id:3,
tipo:"texto",
conteudo:"Classic Smash",
pos_x:30,
pos_y:180,
estilo:{fontSize:16,color:"#fff"}
},

{
id:4,
tipo:"texto",
conteudo:"R$ 25",
pos_x:260,
pos_y:180,
estilo:{fontSize:16,color:"#f1c40f"}
},

{
id:5,
tipo:"texto",
conteudo:"Bacon Smash",
pos_x:30,
pos_y:220,
estilo:{fontSize:16,color:"#fff"}
},

{
id:6,
tipo:"texto",
conteudo:"R$ 29",
pos_x:260,
pos_y:220,
estilo:{fontSize:16,color:"#f1c40f"}
}

]

};